import Vue from "vue";
import VueRouter from "vue-router";
import MainLayout from "../layouts/main/Main.vue";
import LoginLayout from "../layouts/full-page/FullPage.vue";

import MainAppRouter from "./main";
import MahasiswaRouter from "./mahasiswa";
import DosenRouter from "./dosen";
import AkademikRouter from "./akademik";
import TendikRouter from "./tendik";
import DekanRouter from "./dekan";
import FeederRouter from "./feeder";
import SisterRouter from "./sister";
import KepegawaianRouter from "./kepegawaian";
import KorprodiRouter from "./korprodi";
import PerpustakaanRouter from "./perpustakaan";
import LppmRouter from "./lppm";
import TataUsahaRouter from "./tatausaha";
import KoorTaRouter from "./koorta";
import PusdatinRouter from "./pusdatin";
import Lp3mRouter from "./lp3m";
import KerjasamaRouter from "./kerjasama";
import KemahasiswaanRouter from "./kemahasiswaan";
import SpiRouter from "./spi";
import KeuanganRouter from "./keuangan";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [
    //Halaman setelah login
    {
      path: "",
      component: MainLayout,
      children: [
        //ini dari halaman setelah login
        ...MainAppRouter,
        ...MahasiswaRouter,
        ...DosenRouter,
        ...AkademikRouter,
        ...TendikRouter,
        ...DekanRouter,
        ...FeederRouter,
        ...SisterRouter,
        ...KepegawaianRouter,
        ...KorprodiRouter,
        ...PerpustakaanRouter,
        ...LppmRouter,
        ...TataUsahaRouter,
        ...KoorTaRouter,
        ...PusdatinRouter,
        ...Lp3mRouter,
        ...KerjasamaRouter,
        ...KemahasiswaanRouter,
        ...SpiRouter,
        ...KeuanganRouter,
      ],
    },

    //halaman login dan 404
    {
      path: "",
      component: LoginLayout,
      children: [
        {
          path: "/maintenance",
          name: "maintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
        },
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/sso",
          name: "sso-login",
          component: () => import("@/views/pages/SSOLogin.vue"),
        },
        {
          path: "/sipt-login",
          name: "page-sipt-login",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
        {
          path: "/forgot-password",
          name: "forgot-password",
          component: () => import("@/views/pages/ForgotPassword.vue"),
        },
        {
          path: "/new-password/:urlEncoded",
          name: "new-password",
          component: () => import("@/views/pages/NewPassword.vue"),
        },
        {
          path: "/report-orangtua",
          name: "login-orangtua",
          component: () => import("@/views/pages/LoginOrangTua.vue"),
        },
        {
          path: "/report-orangtua/:urlEncoded",
          name: "login-orangtua-encode",
          component: () => import("@/views/pages/AdministrasiDanTranskrip.vue"),
        },
      ],
    },
    {
      path: "*",
      redirect: "/error-404",
    },
  ],
});

router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
